<template>
  <div class="baseInfo">
    <p class="base">基本信息</p>
    <div class="sever-content">
      <p class="header">服务包含</p>
      <ul>
        <li
          v-for="(item, index) in serviceContains"
          v-text="item"
          :key="index"
        ></li>
      </ul>
    </div>
    <div class="aspected-content">
      <p class="header">受理范围</p>
      <ul>
        <li
          v-for="(item, index) in acceptedScope"
          :key="index"
          v-text="item.replace('适用于：', '')"
        ></li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'baseInfo',
  props: ['info'],
  methods: {
    splitDescription(description) {
      if (!description) return [];
      return description.split('\n');
    },
  },
  computed: {
    serviceContains() {
      return (
        this.info && this.info[0] && this.splitDescription(this.info[0].content)
      );
    },
    acceptedScope() {
      return (
        this.info && this.info[1] && this.splitDescription(this.info[1].content)
      );
    },
  },
};
</script>
<style scoped>
.baseInfo {
  padding-left: 0.11rem;
  background-color: #fff;
  border-top: 0.15rem solid #f3f4f6;
}
p.base {
  text-align: center;
  padding: 0.2rem;
  font-style: 'Pingfang SC';
  font-weight: 500;
}
div > div {
  font-size: 0.14rem;
  color: #6f6f6f;
}
ul {
  margin-left: 0.2rem;
  list-style: disc;
  padding-bottom: 0.2rem;
}
li {
  line-height: 0.24rem;
  font-size: 0.14rem;
  padding-right: 0.25rem;
}
.header {
  margin-bottom: 0.1rem;
  color: #444;
}
</style>
